import { useSelector } from "react-redux";

import DialogBox from "../../../components/UI/DialogBox";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import spin from "../../../assets/icons/spin.png";
import { ALL_USER } from "../apiEndpoints";
import UserContainer from "../components/userList/UserContainer";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";

const UsersPage = () => {
  const { isLoaded } = useFetchData(ALL_USER);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout headerConfig={{ title: "Users" }} numberOfData={dataLength}>
      {isLoaded && !error ? (
        <UserContainer />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default UsersPage;
